import React, { useState, useEffect } from "react";
import { API } from "./../../config/api";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./../Styles/ragister.css";

import { useNavigate, useLocation } from "react-router-dom";
import Login from "./Login";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";
export default function Register({ onClose, openLogin }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    country: "India",
    country_code: "91",
    city: "",
    state: "",
    role: "user",
    account_type: "customer",
  });
  const [providerRules, setProviderRules] = useState({});
  const [showLogin, setShowLogin] = useState(false);
  useEffect(() => {
    fetch("/rules.json")
      .then((res) => res.json())
      .then((data) => setProviderRules(data))
      .catch((err) => console.error(err));
  }, []);
  const [showPassword, setShowPassword] = useState(false);
  const [providerOptions, setProviderOptions] = useState(["visitor"]);
  const [supplierType, setSupplierType] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [supplierCategories, setSupplierCategories] = useState([]);
  const [showRules, setShowRules] = useState(false);
  const [pendingOption, setPendingOption] = useState("");
  const [agreeChecked, setAgreeChecked] = useState(false);

  // Store accepted provider rules
  const [acceptedRules, setAcceptedRules] = useState([]);
  useEffect(() => {
    const fetchSupplierCategories = async () => {
      try {
        const response = await fetch(
          `${API.BASE_URL}/api.php?action=supplier_types`,
        );

        const result = await response.json();

        if (result.status) {
          setSupplierCategories(result.data);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchSupplierCategories();
  }, []);

  const validatePhoneNumber = () => {
    const phone = formData.phone;

    // India Validation
    if (formData.country_code === "91") {
      return /^[6-9]\d{9}$/.test(phone);
    }

    // Other countries
    return phone.length >= 6;
  };
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (formData.name.length < 2) {
      newErrors.name = "Name must be at least 2 characters";
    } else if (formData.name.length > 50) {
      newErrors.name = "Name must be less than 50 characters";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!validatePhoneNumber()) {
      const code = formData.country_code;
      if (code === "91") {
        newErrors.phone =
          "Enter valid Indian number (10 digits starting with 6-9)";
      } else if (code === "1") {
        newErrors.phone = "Enter valid US number (10 digits)";
      } else {
        newErrors.phone = "Enter valid international number";
      }
    }

    if (formData.account_type === "provider") {
      const activeOptions = providerOptions.filter((opt) => opt !== "visitor");
      if (activeOptions.length === 0) {
        newErrors.providerOptions = "Please select what you provide";
      }
    }

    if (!formData.city.trim()) newErrors.city = "City is required";
    if (!formData.state.trim()) newErrors.state = "State is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Enter valid email address";
    }

    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, "");
    if (errors.phone) setErrors((prev) => ({ ...prev, phone: "" }));
    setFormData((prev) => ({ ...prev, phone: value }));
  };

  const updateProviderOption = (value, checked) => {
    let updated = [...providerOptions];

    if (checked) {
      // Remove visitor
      updated = updated.filter((item) => item !== "visitor");

      if (!updated.includes(value)) {
        updated.push(value);
      }
    } else {
      // Remove provider option
      updated = updated.filter((item) => item !== value);

      // Remove accepted rule so popup appears next time
      setAcceptedRules((prev) => prev.filter((item) => item !== value));

      if (value === "supplier") {
        setSupplierType([]);
      }

      if (updated.length === 0) {
        updated = ["visitor"];
      }
    }

    setProviderOptions(updated);

    setFormData((prev) => ({
      ...prev,
      account_type: updated.includes("visitor") ? "customer" : "provider",
    }));
  };
  const handleProviderChange = (e) => {
    const { value, checked } = e.target;

    if (errors.providerOptions) {
      setErrors((prev) => ({
        ...prev,
        providerOptions: "",
      }));
    }

    // Visitor
    if (value === "visitor") {
      if (checked) {
        setProviderOptions(["visitor"]);
        setSupplierType([]);
        setAcceptedRules([]);

        setFormData((prev) => ({
          ...prev,
          account_type: "customer",
          terms_accepted: false,
        }));
      }

      return;
    }

    // Check rules available or not
    const selectedRule = providerRules[value];

    const hasRules =
      selectedRule &&
      ((Array.isArray(selectedRule.rules) && selectedRule.rules.length > 0) ||
        (Array.isArray(selectedRule.sections) &&
          selectedRule.sections.length > 0));

    // If checkbox checked
    if (checked) {
      // Show popup only if rules exist
      if (hasRules && !acceptedRules.includes(value)) {
        setPendingOption(value);
        setAgreeChecked(false);
        setShowRules(true);
        return;
      }

      // No rules available -> directly select
      updateProviderOption(value, true);
    } else {
      updateProviderOption(value, false);
    }
  };
  const handleAgreeRules = () => {
    if (!acceptedRules.includes(pendingOption)) {
      setAcceptedRules((prev) => [...prev, pendingOption]);
    }

    updateProviderOption(pendingOption, true);

    setFormData((prev) => ({
      ...prev,
      terms_accepted: true,
    }));

    setAgreeChecked(false);
    setPendingOption("");
    setShowRules(false);
  };
  const handleCancelRules = () => {
    setAgreeChecked(false);
    setPendingOption("");
    setShowRules(false);
  };
  const handleSupplierChange = (e) => {
    const { value, checked } = e.target;
    let updated = [...supplierType];
    if (checked) {
      updated.push(value);
    } else {
      updated = updated.filter((v) => v !== value);
    }
    setSupplierType(updated);
  };

  const resetForm = () => {
    setFormData({
      name: "",
      email: "",
      password: "",
      phone: "",
      country: "India",
      country_code: "91",
      city: "",
      state: "",
      role: "user",
      account_type: "customer",
      terms_accepted: false,
    });

    setProviderOptions(["visitor"]);
    setSupplierType([]);
    setAcceptedRules([]);
    setAgreeChecked(false);
    setPendingOption("");
    setShowRules(false);
    setErrors({});
    setShowPassword(false);
    setIsSubmitting(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      let providerOptionsToSend = providerOptions.filter(
        (opt) => opt !== "visitor",
      );
      const payload = {
        ...formData,

        phone: formData.phone.trim(),

        provider_options: providerOptionsToSend,

        supplier_types: supplierType,

        terms_accepted: formData.terms_accepted,
      };

      const res = await fetch(API.REGISTER, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.success) {
        alert("Account created successfully!");
        setFormData({
          name: "",
          email: "",
          password: "",
          phone: "",
          country: "India",
          country_code: "91",
          city: "",
          state: "",
          role: "user",
          account_type: "customer",
          terms_accepted: false,
        });

        setAcceptedRules([]);

        setAgreeChecked(false);

        setPendingOption("");

        setShowRules(false);
        setProviderOptions(["visitor"]);
        setSupplierType([]);
        setErrors({});
        setShowLogin(true);
      } else {
        alert(data.message || "Registration failed");
      }
    } catch (error) {
      console.error("Registration error:", error);
      alert("Server error. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="register-page">
      <div className="register-container">
        <div className="register-header">
          <h2>Create Your Account</h2>
          <p>
            Fill your personal details and choose what services you want to
            provide on Embroidery Bazar.
          </p>
        </div>
        <form className="register-form" onSubmit={handleSubmit} noValidate>
          <div className="register-layout">
            {}

            {}
            <div className="register-right">
              <div
                className={`register-popup-provider-box ${errors.providerOptions ? "box-error" : ""}`}
              >
                <h4 className="register-popup-provider-title">
                  What services do you provide?
                </h4>
                <div className="register-popup-checkbox-list">
                  {[
                    {
                      value: "visitor",
                      label: "I am a Visitor / Customer",
                    },
                    {
                      value: "job_worker",
                      label: "I am Job worker",
                    },
                    {
                      value: "designers",
                      label: "I am Designer (Create Profile)",
                    },
                    {
                      value: "Sketcher",
                      label: "I am a Sketcher(Create Profile)",
                    },
                    {
                      value: "designs",
                      label: "I want to Sell Embroidery Designs",
                    },
                    {
                      value: "machines",
                      label: "I want to Sell Embroidery Machines",
                    },
                    {
                      value: "workspaces",
                      label: "I want to give Workspace on Rent",
                    },
                    {
                      value: "supplier",
                      label: "I Am Supplier",
                    },
                  ].map((opt) => (
                    <label
                      key={opt.value}
                      className="register-popup-checkbox-card"
                    >
                      <input
                        type="checkbox"
                        value={opt.value}
                        checked={providerOptions.includes(opt.value)}
                        onChange={handleProviderChange}
                      />
                      <div className="checkbox-custom-design"></div>
                      <span>{opt.label}</span>
                    </label>
                  ))}
                </div>
                {errors.providerOptions && (
                  <span className="register-popup-error">
                    {errors.providerOptions}
                  </span>
                )}
              </div>

              {}
              {providerOptions.includes("supplier") && (
                <div className="register-popup-supplier-box animation-fade-in">
                  <h4>Specify Supplier Category</h4>

                  <div className="register-popup-checkbox-list">
                    {supplierCategories.map((sup) => (
                      <label
                        key={sup.id}
                        className="register-popup-checkbox-card secondary"
                      >
                        <input
                          type="checkbox"
                          value={sup.type}
                          checked={supplierType.includes(sup.type)}
                          onChange={handleSupplierChange}
                        />

                        <div className="checkbox-custom-design"></div>

                        <span>{sup.display_name}</span>
                      </label>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="register-left">
              <div className="register-popup-group">
                <label className="register-label">Full Name</label>
                <input
                  name="name"
                  placeholder="e.g. John Doe"
                  className={`register-popup-input ${errors.name ? "error-field" : ""}`}
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && (
                  <span className="register-popup-error">{errors.name}</span>
                )}
              </div>

              {}
              <div className="register-popup-group">
                <label className="register-label">Mobile Number</label>
                <PhoneInput
                  country={"in"}
                  enableSearch={true}
                  value={`${formData.country_code}${formData.phone}`}
                  onChange={(phone, country) => {
                    const dialCode = country.dialCode;

                    const mobile = phone.startsWith(dialCode)
                      ? phone.slice(dialCode.length)
                      : phone;

                    if (errors.phone) {
                      setErrors((prev) => ({ ...prev, phone: "" }));
                    }

                    setFormData((prev) => ({
                      ...prev,
                      phone: mobile,
                      country_code: dialCode,
                      country: country.name,
                    }));
                  }}
                  inputStyle={{
                    width: "100%",
                    height: "46px",
                    borderRadius: "8px",
                  }}
                  containerStyle={{
                    width: "100%",
                  }}
                />
                {errors.phone && (
                  <span className="register-popup-error">{errors.phone}</span>
                )}
              </div>

              {}
              <div className="register-location-grid">
                <div className="register-popup-group">
                  <label className="register-label">City</label>
                  <input
                    name="city"
                    placeholder="City"
                    className={`register-popup-input ${errors.city ? "error-field" : ""}`}
                    value={formData.city}
                    onChange={handleChange}
                  />
                  {errors.city && (
                    <span className="register-popup-error">{errors.city}</span>
                  )}
                </div>

                <div className="register-popup-group">
                  <label className="register-label">State</label>
                  <input
                    name="state"
                    placeholder="State"
                    className={`register-popup-input ${errors.state ? "error-field" : ""}`}
                    value={formData.state}
                    onChange={handleChange}
                  />
                  {errors.state && (
                    <span className="register-popup-error">{errors.state}</span>
                  )}
                </div>

                <div className="register-popup-group">
                  <label className="register-label">Country</label>
                  <input
                    name="country"
                    placeholder="Country"
                    className={`register-popup-input ${errors.country ? "error-field" : ""}`}
                    value={formData.country}
                    onChange={handleChange}
                  />
                  {errors.country && (
                    <span className="register-popup-error">
                      {errors.country}
                    </span>
                  )}
                </div>
              </div>
              <div className="register-popup-group">
                <label className="register-label">
                  Email Address <span className="optional-tag"></span>
                </label>
                <input
                  name="email"
                  type="email"
                  placeholder="name@example.com"
                  className={`register-popup-input ${errors.email ? "error-field" : ""}`}
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                {errors.email && (
                  <span className="register-popup-error">{errors.email}</span>
                )}
              </div>

              {}
              <div className="register-popup-group">
                <label className="register-label">Password</label>
                <div className="password-wrapper">
                  <input
                    name="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Minimum 6 characters"
                    className={`register-popup-input ${errors.password ? "error-field" : ""}`}
                    value={formData.password}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    tabIndex="-1"
                  >
                    <i
                      className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                    ></i>
                  </button>
                </div>
                {errors.password && (
                  <span className="register-popup-error">
                    {errors.password}
                  </span>
                )}
              </div>
              <button
                type="submit"
                className="register-popup-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span className="spinner-wrapper">
                    <span className="btn-spinner"></span> Processing...
                  </span>
                ) : (
                  "Create My Account"
                )}
              </button>
              <div className="register-popup-footer">
                Already have an account?{" "}
                <span
                  className="register-popup-link"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/", {
                      state: {
                        openLogin: true,
                      },
                    });
                  }}
                >
                  Sign In here
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>
      {}
      <Login
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        openRegister={() => {
          setShowLogin(false);
        }}
      />
      {showRules && (
        <div className="register-popup-overlay">
          <div className="register-popup-card">
            <div className="rules-popup-header">
              <h3>{providerRules[pendingOption]?.title}</h3>
            </div>

            <div className="rules-popup-body">
              <div className="rules-warning">
                <i className="bi bi-exclamation-triangle-fill"></i>

                <span>Please read all rules carefully before continuing.</span>
              </div>

              <div className="rules-list">
                {}
                {providerRules[pendingOption]?.sections ? (
                  providerRules[pendingOption].sections.map(
                    (section, sIndex) => (
                      <div key={sIndex} className="rules-section">
                        <h4 className="rules-heading">{section.heading}</h4>

                        <ul>
                          {section.rules.map((rule, rIndex) => (
                            <li key={rIndex}>
                              <i className="bi bi-check-circle-fill"></i>
                              {rule}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ),
                  )
                ) : (
                  <ul>
                    {providerRules[pendingOption]?.rules?.map((rule, index) => (
                      <li key={index}>
                        <i className="bi bi-check-circle-fill"></i>
                        {rule}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div className="rules-agreement">
                <label>
                  <input
                    type="checkbox"
                    checked={agreeChecked}
                    onChange={(e) => setAgreeChecked(e.target.checked)}
                  />

                  <span>
                    મેં ઉપર લખેલ તમામ શરતો અને નિયમો વાંચ્યા છે અને તેનું પાલન
                    કરવા માટે સંમત છું.
                  </span>
                </label>
              </div>
            </div>

            <div className="rules-popup-footer">
              <button
                type="button"
                className="rules-cancel-btn"
                onClick={handleCancelRules}
              >
                Cancel
              </button>

              <button
                type="button"
                className="rules-agree-btn"
                disabled={!agreeChecked}
                onClick={handleAgreeRules}
              >
                <i className="bi bi-check2-circle"></i>I Agree
              </button>
            </div>
          </div>
        </div>
      )}
      <HorizontalAds />
    </div>
  );
}
